const RESTS = [
  '/wp-json/webkust/v1/postcode',
  '/wp-json/webkust/v1/postcode-lookup',
  '/wp-json/webkust/v1/postcode/'
];

const SEL = {
  billing: {
    postcode: ['#acf-field_billing_postcode', '.acf-field[data-key="field_billing_postcode"] input', '#billing_postcode'],
    number:   ['#acf-field_billing_house_number', '.acf-field[data-key="field_billing_house_number"] input', '#billing_house_number'],
    suffix:   ['#acf-field_billing_house_number_suffix', '.acf-field[data-key="field_billing_house_number_suffix"] input', '#billing_house_number_suffix'],
    street:   ['#acf-field_billing_street', '.acf-field[data-key="field_billing_street"] input', '#billing_street', '#billing_address_1'],
    city:     ['#acf-field_billing_city', '.acf-field[data-key="field_billing_city"] input', '#billing_city'],
  },
  shipping: {
    postcode: ['#acf-field_shipping_postcode', '.acf-field[data-key="field_shipping_postcode"] input', '#shipping_postcode'],
    number:   ['#acf-field_shipping_house_number', '.acf-field[data-key="field_shipping_house_number"] input', '#shipping_house_number'],
    suffix:   ['#acf-field_shipping_house_number_suffix', '.acf-field[data-key="field_shipping_house_number_suffix"] input', '#shipping_house_number_suffix'],
    street:   ['#acf-field_shipping_street', '.acf-field[data-key="field_shipping_street"] input', '#shipping_street', '#shipping_address_1'],
    city:     ['#acf-field_shipping_city', '.acf-field[data-key="field_shipping_city"] input', '#shipping_city'],
  }
};

function q(arr, root=document){ for (const s of arr){ const el=root.querySelector(s); if (el) return el; } return null; }
const normPC = v => (v||'').replace(/\s+/g,'').toUpperCase();
const isNLPC = v => /^\d{4}[A-Za-z]{2}$/.test(v||'');

async function viaProxy(pc, no, sx){
  const qs = `postcode=${encodeURIComponent(pc)}&number=${encodeURIComponent(no)}&suffix=${encodeURIComponent(sx||'')}`;
  for (const base of RESTS) {
    try { const r = await fetch(`${base}?${qs}`, {headers:{Accept:'application/json'}}); if (r.ok) return await r.json(); } catch(_) {}
  }
  return null;
}
async function viaDirect(pc, no){
  const key = window.POSTCODE_API_KEY;
  if (!key) return null;
  try {
    const r = await fetch(`https://postcode.tech/api/v1/postcode?postcode=${pc}&number=${no}`, {headers:{Authorization:`Bearer ${key}`}});
    if (!r.ok) return null;
    const d = await r.json();
    return { ok:true, street:d.street, city:d.city };
  } catch(_) { return null; }
}

function showError(input, msg){
  clearErrors(input);
  const el = document.createElement('div');
  el.className = 'woocommerce-error postcode-error';
  el.textContent = msg;
  (input.closest('.acf-field') || input.closest('.form-row') || input.parentElement)?.appendChild(el);
}
function clearErrors(input){
  const root = (input && (input.closest('.acf-field') || input.closest('.form-row'))) || document;
  root.querySelectorAll('.postcode-error').forEach(n => n.remove());
}

async function lookup(section, ctx=document){
  const S = SEL[section];
  const pcEl=q(S.postcode,ctx), noEl=q(S.number,ctx), sxEl=q(S.suffix,ctx), stEl=q(S.street,ctx), ctEl=q(S.city,ctx);
  if (!pcEl || !noEl || !stEl || !ctEl) return;

  const pc = normPC(pcEl.value);
  const no = (noEl.value||'').trim();
  const sx = (sxEl?.value||'').trim();
  if (!isNLPC(pc) || !no) return;

  clearErrors(pcEl);

  let data = await viaProxy(pc, no, sx);
  if (!data || data.ok === false) data = await viaDirect(pc, no);

  if (data && data.ok && (data.street || data.city)) {
    if (!stEl.value) stEl.value = data.street || '';
    if (!ctEl.value) ctEl.value = data.city   || '';
    ['input','change'].forEach(ev=>{
      stEl.dispatchEvent(new Event(ev,{bubbles:true}));
      ctEl.dispatchEvent(new Event(ev,{bubbles:true}));
    });
  } else {
    showError(pcEl, 'Adres niet gevonden. Controleer postcode en huisnummer.');
  }
}

function bind(section, ctx=document){
  const S = SEL[section];
  const pc=q(S.postcode,ctx), no=q(S.number,ctx), sx=q(S.suffix,ctx);
  if (!pc || !no) return;

  const trigger = ()=>lookup(section, ctx);
  const deb = ((fn,ms=250)=>{ let t; return (...a)=>{ clearTimeout(t); t=setTimeout(()=>fn(...a),ms); }; })(trigger, 300);

  if (!pc.dataset.wkPcBound){ pc.dataset.wkPcBound='1'; pc.addEventListener('blur',trigger); pc.addEventListener('change',trigger); pc.addEventListener('input',deb); }
  if (!no.dataset.wkPcBound){ no.dataset.wkPcBound='1'; no.addEventListener('blur',trigger); no.addEventListener('change',trigger); no.addEventListener('input',deb); }
  if (sx && !sx.dataset.wkPcBound){ sx.dataset.wkPcBound='1'; sx.addEventListener('blur',trigger); sx.addEventListener('change',trigger); sx.addEventListener('input',deb); }
}

/* Public API */
export function mountPostcodeACF(root=document){
  bind('billing',  root);
  bind('shipping', root);

  ['updated_checkout','wc_fragment_refresh','updated_shipping_method']
    .forEach(evt => document.body.addEventListener(evt, () => {
      bind('billing',  document);
      bind('shipping', document);
    }));

  if (window.jQuery) {
    jQuery(document).on('acf/ready acf/append', (_e, $el) => {
      const ctx = ($el && $el[0]) || document;
      bind('billing',  ctx);
      bind('shipping', ctx);
    });
  }
}

// alias + default
export function mount(){ mountPostcodeACF(document); }
export default { mount: mountPostcodeACF };

// autorun voor directe include
if (document.readyState !== 'loading') mountPostcodeACF(document);
else document.addEventListener('DOMContentLoaded', () => mountPostcodeACF(document));
